module.exports = __webpack_public_path__ + "static/img/ai_content.8f813f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/matrix/ai_content.png
// module id = +KcS
// module chunks = 34